// src/routes/routes.js
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";

// Auth Pages
import Signin from "../pages/common/signin";
import AuthPasswordReset from "../pages/common/passwordReset";
import AuthPasswordForGet from "../pages/common/passwordForget";
import AccountMailSend from "../pages/common/accountMailSend";
import AuthPasswordCreate from "../pages/common/passwordCreate";
import PasswordMailSend from "../pages/common/passwordMailSend";
import NotFound from "../pages/common/NotFound";
import Signup from "../pages/common/sIgnup";

// Report Pages
import ReportAirconList from "../pages/admin/reportAircon/reportAirconList";
import ReportAirconDetail from "../pages/admin/reportAircon/reportAirconDetail";
import ReportFoodList from "../pages/admin/reportFood/reportFoodList";
import ReportFoodDetail from "../pages/admin/reportFood/reportFoodDetail";
import ReportFreeList from "../pages/admin/reportFree/reportFreeList";
import ReportFreeDetail from "../pages/admin/reportFree/reportFreeDetail";

// Order Pages
import OrderFormList from "../pages/admin/orderForm/orderFormList";
import OrderFormDetail from "../pages/admin/orderForm/orderFormDetail";

// Master Management Pages
import ManufacturerList from "../pages/admin/manufacture/manufactureList";
import ManufactureDetail from "../pages/admin/manufacture/manufactureDetail";
import SalesPersonList from "../pages/admin/salesPerson/salesPersonList";
import SalesPersonDetail from "../pages/admin/salesPerson/salesPersonDetail";
import WorkTypeList from "../pages/admin/workType/workTypeList";
import WorkTypeDetail from "../pages/admin/workType/workTypeDetail";

// Account Pages
import AccountList from "../pages/admin/account/accountList";
import AccountDetail from "../pages/admin/account/accountDetail";
import { PATHS } from "./paths";
import { AuthGuard } from "./AuthGuard";
import ReportFloorList from "../pages/admin/reportFloor/reportFloorList";
import ReportFloorDetail from "../pages/admin/reportFloor/reportFloorDetail";

// Public routes that don't require authentication
const publicRoutes = [
  { path: "/", element: <Navigate replace to={PATHS.AUTH_SIGN_IN} /> },
  { path: PATHS.AUTH_SIGN_IN, element: <Signin /> },
  { path: PATHS.AUTH_SIGN_UP, element: <Signup /> },
  { path: PATHS.AUTH_PASSWORD_RESET, element: <AuthPasswordReset /> },
  { path: PATHS.AUTH_PASSWORD_FORGET, element: <AuthPasswordForGet /> },
  { path: PATHS.AUTH_ACCOUNT_MAIL_SEND, element: <AccountMailSend /> },
  { path: PATHS.AUTH_PASSWORD_CREATE, element: <AuthPasswordCreate /> },
  { path: PATHS.AUTH_PASSWORD_MAIL_SEND, element: <PasswordMailSend /> },
  { path: PATHS.NOTFOUND, element: <NotFound /> },
];

// Protected routes that require authentication
const privateRoutes = [
  // Report routes
  { path: PATHS.REPORT_AIRCON_LIST, element: <ReportAirconList /> },
  { path: PATHS.REPORT_AIRCON_DETAIL, element: <ReportAirconDetail /> },
  { path: PATHS.REPORT_FOOD_LIST, element: <ReportFoodList /> },
  { path: PATHS.REPORT_FOOD_DETAIL, element: <ReportFoodDetail /> },
  { path: PATHS.REPORT_FLOOR_LIST, element: <ReportFloorList /> },
  { path: PATHS.REPORT_FLOOR_DETAIL, element: <ReportFloorDetail /> },
  { path: PATHS.REPORT_FREE_LIST, element: <ReportFreeList /> },
  { path: PATHS.REPORT_FREE_DETAIL, element: <ReportFreeDetail /> },

  // Order routes
  { path: PATHS.ORDER_LIST, element: <OrderFormList /> },
  { path: PATHS.ORDER_DETAIL, element: <OrderFormDetail /> },

  // Master Management routes
  { path: PATHS.MANUFACTURER_LIST, element: <ManufacturerList /> },
  { path: PATHS.MANUFACTURER_DETAIL, element: <ManufactureDetail /> },
  { path: PATHS.SALES_PERSON_LIST, element: <SalesPersonList /> },
  { path: PATHS.SALES_PERSON_DETAIL, element: <SalesPersonDetail /> },
  { path: PATHS.WORK_TYPE_LIST, element: <WorkTypeList /> },
  { path: PATHS.WORK_TYPE_DETAIL, element: <WorkTypeDetail /> },

  // Account routes
  { path: PATHS.ACCOUNT_LIST, element: <AccountList /> },
  { path: PATHS.ACCOUNT_DETAIL, element: <AccountDetail /> },


  { path: "*", element: <Navigate to={PATHS.NOTFOUND} /> },

];


const router = createBrowserRouter([
  ...publicRoutes,
  {
    path: "/",
    element: <AuthGuard />,
    children: [
      {
        children: privateRoutes,
      },
    ],
  },
]);


export function AppRoutes() {
  return <RouterProvider router={router} />;
}
